import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Button,
  Row,
  Col,
} from "reactstrap";
import CoreEngine from "../../core/CoreEngine";
import RequestEngine from "../../core/RequestEngine";
import { connect } from "react-redux";
import loadingAction from "../../core/redux/actions/loadingAction";
import ReactTable from "react-table";
import TablePagination from "components/Table/TablePagination";
import strings from "../../core/translate";
import RowActions, {
  editAction,
  deleteAction,
} from "components/Table/RowActions";
import SelectRow from "../../components/Select/SelectRow";
import { Scopes } from "../../shared/scopes.enum";

class MerchantSubItemList extends CoreEngine {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      dataSource: [],
      items: [],
      selectedItem: "",
      canWrite: false,
    };

    this.engine = new RequestEngine();
  }

  componentDidMount() {
    const merchantIdFromStorage = sessionStorage.getItem("merchantId");
    const { selectedItem } = this.props.match.params;
    const canWrite = this.hasPermission([Scopes.MERCHANTS_SUBITEMS_WRITE]);
    this.setState({ canWrite });

    if (merchantIdFromStorage) {
      this.setState({ selectedMerchant: merchantIdFromStorage });
      if (selectedItem) {
        this.setState({ selectedItem }, this.callPage);
      }
      this.fetchItems(merchantIdFromStorage);
    }
  }

  fetchItems = async (merchantId) => {
    const response = await this.engine.getItem(`merchants/${merchantId}/items`);
    if (response && response.status === 200) {
      this.setState({
        items: response.data.items.map((item) => ({
          value: item.id,
          label: `${item.code} - ${item.description}`,
        })),
        isLoading: false,
      });
    } else {
      console.error("Failed to fetch items:", response);
    }
  };

  async handleDelete(valueid) {
    const { selectedItem } = this.state;
    if (window.confirm(strings.confirmdelete)) {
      this.props.loadingAction(true);
      const result = await this.engine.deleteItem(
        `merchants/{merchantId}/sub-items/${selectedItem}`,
        valueid
      );

      if (result.status === 200) {
        this.handlePage();
      }
      this.props.loadingAction(false);
    }
  }

  handlePage() {
    this.props.loadingAction(true);
    this.callPage();
  }

  async callPage() {
    const { selectedItem } = this.state;

    if (!selectedItem || selectedItem === ":selectedItem") return;

    const pathname = `merchants/{merchantId}/sub-items/${selectedItem}`;
    const response = await this.engine.getItem(pathname);

    if (response && response.status === 200) {
      this.setState({
        isLoading: false,
        dataSource: response.data.items.map((item, key) => ({
          id: key,
          data: item,
          code: item.code,
          description: item.description,
          itemCode: item.code,
          created: new Date(item.createdAt),
          actions: this.handleActions(key, item),
        })),
      });
    }

    this.props.loadingAction(false);
  }
  handleActions(index, item) {
    return (
      <RowActions
        actions={[
          editAction(() => this.handleEdit(index, item.id), this.state.canWrite),
          deleteAction(() => this.handleDelete(item.id), this.state.canWrite),
        ]}
      />
    );
  }

  handleItemSelect = (event) => {
    const selectedItem = event.value;
    this.setState({ selectedItem }, () => {
      this.props.history.push(`/admin/merchant/${selectedItem}/subitems`);
      this.callPage();
    });
  };

  handleAdd = () => {
    const { selectedItem } = this.state;
    console.log(selectedItem);

    if (!selectedItem || selectedItem === ":selectedItem") {
      alert(`${strings.select} ${strings.item}`);
      return;
    }
    this.props.history.push(`/admin/merchant/${selectedItem}/subitems/add`);
  };

  handleEdit(index, dataid) {
    const data = this.state.dataSource[index].data;
    const { selectedItem } = this.state;
    this.props.history.push({
      pathname: `/admin/merchant/${selectedItem}/subitems/edit/${dataid}`,
      data,
      selectedItem,
    });
  }

  render() {
    const { dataSource, isLoading, items, selectedItem, canWrite } = this.state;

    const columns = [
      {
        Header: strings.code,
        accessor: "code",
      },
      {
        Header: strings.description,
        accessor: "description",
      },
      {
        Header: strings.itemcode,
        accessor: "itemCode",
      },
      {
        Header: strings.created,
        accessor: "created",
        Cell: (row) => row.value.toLocaleDateString(),
      },
      {
        Header: strings.actions,
        accessor: "actions",
        sortable: false,
        filterable: false,
      },
    ];

    return (
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4" className="pull-left"></CardTitle>
                {canWrite && (
                  <Button
                    color="primary"
                    className="pull-right"
                    onClick={this.handleAdd}
                  >
                    {strings.add}
                  </Button>
                )}

                <SelectRow
                  label={strings.item}
                  name="selectedItem"
                  defaultValue={selectedItem}
                  data={items}
                  changeInput={this.handleItemSelect}
                  placeholder={strings.select}
                />
              </CardHeader>
              <CardBody>
                <ReactTable
                  previousText={strings.previous}
                  nextText={strings.next}
                  loadingText={strings.loading}
                  noDataText={strings.nodata}
                  pageText={strings.page}
                  data={dataSource}
                  defaultFilterMethod={this.filterCaseInsensitive}
                  filterable
                  loading={isLoading}
                  columns={columns}
                  defaultPageSize={10}
                  showPaginationTop={false}
                  showPaginationBottom
                  PaginationComponent={TablePagination}
                  className="-striped -highlight primary-pagination"
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  loadingAction: (payload) => dispatch(loadingAction(payload)),
});

export default connect(null, mapDispatchToProps)(MerchantSubItemList);
